module.exports = __webpack_public_path__ + "img/icon-winnings.551db3be.png";